module.exports = __webpack_public_path__ + "img/robot01_on.c13f13b4.png";